import { render, staticRenderFns } from "./returnGoodslistNew.vue?vue&type=template&id=3e656c7c&scoped=true"
import script from "./returnGoodslistNew.vue?vue&type=script&lang=js"
export * from "./returnGoodslistNew.vue?vue&type=script&lang=js"
import style0 from "./returnGoodslistNew.vue?vue&type=style&index=0&id=3e656c7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e656c7c",
  null
  
)

export default component.exports